module.exports = __webpack_public_path__ + "images/avatars/male/11.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/11.png
// module id = D9F/
// module chunks = 55